import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo, useMemo } from 'react';
import { ItemVM } from 'shell/view-models/item';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponseList } from 'shell/models/http-response';
import { TypeDestination } from 'shell/models/type-destination';
import { AxiosResponse } from 'axios';
import { __OPERATION__EVENT__ADMIN__ } from 'shell/constants/environment';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { PmiSelect } from 'shell/components/shared/pmi-select';

interface TypeDestinationListComponentProps {
  disabled?: boolean;
  required?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  onBlur?: () => void;
  error?: boolean;
}

const TypeDestinationtListComponent = ({
  disabled,
  onChange,
  onBlur = () => {
    return;
  },
  value,
  error,
  required,
}: TypeDestinationListComponentProps): React.ReactElement => {
  const [typeDestinations] = useHttpFetch<HttpResponseList<TypeDestination>, Array<ItemVM>>(
    `${__OPERATION__EVENT__ADMIN__}/tipoDestinazione/list`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: {},
      },
      transformer: (response: AxiosResponse<HttpResponseList<TypeDestination>>) => {
        const data = response.data.payload?.list || [];
        const list = data.map((item: TypeDestination) => ({
          id: item?.codice,
          value: item?.descrizione.toString(),
        }));

        return list;
      },
    }
  );

  const typeDestinationsList = useMemo(() => {
    const data = (typeDestinations.data as Array<ItemVM>) || [];
    const res = data.sort((a, b) => {
      if (a.id > b.id) return 1;
      if (a.id < b.id) return -1;
      return 0;
    });
    return res;
  }, [typeDestinations]);

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id="typedestination-label">
        {required ? 'Tipo Destinazione *' : 'Tipo Destinazione'}
      </InputLabel>
      <PmiSelect
        labelId="typedestination-label"
        id="destinationCode"
        name="destinationCode"
        value={value}
        label={required ? 'Tipo Destinazione *' : 'Tipo Destinazione'}
        onChange={onChange}
        disabled={disabled}
        error={error}
        onBlur={onBlur}
      >
        <MenuItem value="">
          <em>Tutti</em>
        </MenuItem>
        {typeDestinationsList
          ? typeDestinationsList.map((item: ItemVM) => (
              <MenuItem key={item.id} value={item.id}>
                {item.value}
              </MenuItem>
            ))
          : undefined}
      </PmiSelect>
    </PmiFormControl>
  );
};

TypeDestinationtListComponent.displayName = 'Type destination item component';

const TypeDestinationList = memo(TypeDestinationtListComponent);

export default TypeDestinationList as typeof TypeDestinationtListComponent;
